"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));
var _styles = require("@material-ui/core/styles");
var _SttText = _interopRequireDefault(require("./SttTypography/SttText"));
var _SttContainer = _interopRequireDefault(require("./SttLayout/SttContainer"));
var _SttCircularProgress = _interopRequireDefault(require("./SttCircularProgress"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    paper: {
      display: 'flex',
      padding: theme.spacing(3, 4, 3),
      alignItems: 'center'
    },
    text: {
      paddingLeft: theme.spacing(3)
    }
  };
});
function SttLoading(props) {
  var classes = useStyles();
  var open = props.open,
    text = props.text,
    progress = props.progress;
  return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
    open: open
  }, /*#__PURE__*/_react["default"].createElement(_SttContainer["default"], {
    className: classes.paper
  }, progress ? /*#__PURE__*/_react["default"].createElement(_SttCircularProgress["default"], {
    variant: "determinate",
    value: progress
  }) : /*#__PURE__*/_react["default"].createElement(_SttCircularProgress["default"], null), text && /*#__PURE__*/_react["default"].createElement(_SttText["default"], {
    className: classes.text
  }, text)));
}
SttLoading.propTypes = {
  open: _propTypes["default"].bool,
  text: _propTypes["default"].string
};
var _default = SttLoading;
exports["default"] = _default;